<div class="wizard-modal">
  <nb-card class="dialog-wide wizard-modal-card">
    <nb-card-body>
      <div *ngIf="isLoading" class="wizard-modal-loading-mask">
        <div style="display: flex; justify-content: center; margin-top: 25%">
          <i style="font-size: 30px" class="fas fa-spinner fa-spin"></i>
        </div>
      </div>
      <div class="wizard-modal-top-row">
        <h5 class="wizard-modal-title">{{"archiving_set_up_wizard"|translation}}</h5>
        <button
          nbSuffix
          style="background: transparent"
          nbButton
          ghost
          status="basic"
          (click)="closeModal(true)"
        >
          <i class="fa-solid fa-xmark" style="font-size: 20px;color:#000;"></i>
        </button>
      </div>
      <nb-stepper
        [selectedIndex]="selectedIndex"
        orientation="vertical"
        linear="false"
        (stepChange)="updateStep($event)"
      >
        <nb-step
          #nbStep
          [completed]="indirectTasksHasCompleted(i)"
          [stepControl]="{
            valid: indirectTasksHasCompleted(index),
            reset: null
          }"
          *ngFor="let step of steps; let i = index"
          [label]="step?.translation_key|translation"
        >
          <div class="wizard-modal-content">
            <div class="wizard-modal-content-top">
              <ng-container [ngSwitch]="step?.component">
                <app-wizard-integrations
                  *ngSwitchCase="'WizardIntegrations'"
                ></app-wizard-integrations>
                <app-wizard-theme
                  *ngSwitchCase="'WizardTheme'"
                ></app-wizard-theme>
                <app-wizard-users
                  *ngSwitchCase="'WizardUsers'"
                ></app-wizard-users>
                <app-wizard-import
                  *ngSwitchCase="'WizardImportComponent'"
                ></app-wizard-import>
              </ng-container>
            </div>
            <div class="wizard-modal-content-bottom">
              <button
                class="wizard-modal-content-bottom-button"
                nbButton
                [disabled]="i === 0"
                nbStepperPrevious
                ghost
              >
              {{"back"|translation}}
              </button>
              <button
                class="wizard-modal-content-bottom-button"
                nbButton
                status="primary"
                (click)="closeModal(i === steps.length - 1)"
                nbStepperNext
              >
                {{ forwardButtonContent|translation }}
              </button>
            </div>
          </div>
        </nb-step>
      </nb-stepper>
    </nb-card-body>
  </nb-card>
</div>
